import * as tslib_1 from "tslib";
import { debounceTime } from 'rxjs/operators';
import { OnInit, OnDestroy } from '@angular/core';
import { Business } from '../models/business.model';
import { hasTag, getSubTags, loadTags } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { TagService } from '../../shared/services/tag.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { FlightSchool } from '../models/flight-school.model';
import { FormControl, Validators } from '@angular/forms';
var TrainingComponent = /** @class */ (function () {
    function TrainingComponent(_toggleService, _tagService, _businessManagerService, _editTrainingDialog, snackBar) {
        var _this = this;
        this._toggleService = _toggleService;
        this._tagService = _tagService;
        this._businessManagerService = _businessManagerService;
        this._editTrainingDialog = _editTrainingDialog;
        this.snackBar = snackBar;
        this.classificationTags = [];
        this.servicesTags = [];
        this.certificationTags = [];
        this.ratingTags = [];
        this.advancedTrainingTags = [];
        this.hasTag = hasTag;
        this.getSubTags = getSubTags;
        this.editModeSet = false;
        this.fullTimeInstructorRangeControl = new FormControl('', [Validators.min(0), Validators.max(200)]);
        this.partTimeInstructorRangeControl = new FormControl('', [Validators.min(0), Validators.max(200)]);
        this.contractInstructorRangeControl = new FormControl('', [Validators.min(0), Validators.max(200)]);
        //#endregion
        this.isRegionalManager = false;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    }
    TrainingComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loadAllBusinessTags();
                        return [4 /*yield*/, this._tagService.getAllTags().then(function (allTags) {
                                _this.setVaApprovedTagAndBool(allTags);
                                _this.setPrivateTagAndBool(allTags);
                            })];
                    case 1:
                        _c.sent();
                        this.setCollegeName();
                        this.setFullTimeCfiCount();
                        this.setPartTimeCfiCount();
                        this.setContractedCfiCount();
                        this.setCfi_FullTime_Subscription$();
                        this.setCfi_PartTime_Subscription$();
                        this.setCfi_Contract_Subscription$();
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 2:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 3:
                        _b = !(_c.sent());
                        _c.label = 4;
                    case 4:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    TrainingComponent.prototype.ngOnDestroy = function () {
        this.cfi_FullTime_Subscription$.unsubscribe();
        this.cfi_PartTime_Subscription$.unsubscribe();
        this.cfi_Contracted_Subscription$.unsubscribe();
    };
    Object.defineProperty(TrainingComponent.prototype, "hasContent", {
        get: function () {
            /* uncomment below line if flight instructor counts come back */
            // return this.hasTrainingData || this.hasTrainingOpportunitiesData || this.hasFlightSchoolData;
            return this.hasTrainingData || this.hasTrainingOpportunitiesData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrainingComponent.prototype, "hasTrainingData", {
        get: function () {
            return (this.classificationTags.length > 0 || this.servicesTags.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrainingComponent.prototype, "hasTrainingOpportunitiesData", {
        get: function () {
            return (this.certificationTags.length > 0 || this.ratingTags.length > 0 ||
                this.advancedTrainingTags.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrainingComponent.prototype, "hasFlightSchoolData", {
        get: function () {
            return this.business.flightSchool ?
                (this.business.flightSchool.cfiCountFull > 0 ||
                    this.business.flightSchool.cfiCountPart > 0 ||
                    this.business.flightSchool.cfiCountContract > 0) : false;
        },
        enumerable: true,
        configurable: true
    });
    //#region NgInit Methods
    TrainingComponent.prototype.loadAllBusinessTags = function () {
        this.classificationTags = loadTags(this.business.tags, 'Flight Training::Classification::', '', '');
        this.servicesTags = loadTags(this.business.tags, 'Flight Training::Services::', '', '');
        this.certificationTags = loadTags(this.business.tags, 'Flight Training::Certification::', '', '');
        this.ratingTags = loadTags(this.business.tags, 'Flight Training::Rating::', '', '');
        this.advancedTrainingTags = loadTags(this.business.tags, 'Flight Training::Advanced::', '', '');
    };
    TrainingComponent.prototype.setFullTimeCfiCount = function () {
        if (this.business.flightSchool
            && (this.business.flightSchool.cfiCountFull
                || this.business.flightSchool.cfiCountFull === 0)) {
            this.cfi_FullTime = this.business.flightSchool.cfiCountFull;
        }
        else {
            this.cfi_FullTime = null;
        }
    };
    TrainingComponent.prototype.setPartTimeCfiCount = function () {
        if (this.business.flightSchool
            && (this.business.flightSchool.cfiCountPart
                || this.business.flightSchool.cfiCountPart === 0)) {
            this.cfi_PartTime = this.business.flightSchool.cfiCountPart;
        }
        else {
            this.cfi_PartTime = null;
        }
    };
    TrainingComponent.prototype.setContractedCfiCount = function () {
        if (this.business.flightSchool
            && (this.business.flightSchool.cfiCountContract
                || this.business.flightSchool.cfiCountContract === 0)) {
            this.cfi_Contracted = this.business.flightSchool.cfiCountContract;
        }
        else {
            this.cfi_Contracted = null;
        }
    };
    TrainingComponent.prototype.setCollegeName = function () {
        if (this.business.collegeName) {
            this.collegeName = this.business.collegeName;
        }
    };
    TrainingComponent.prototype.setVaApprovedTagAndBool = function (bTags) {
        this.vaApprovedTag = this._tagService.findTagByName(bTags, 'Flight Training::VA Approved');
        this.isApprovedForVaTraining = hasTag(this.business.tags, this.vaApprovedTag.tagName);
    };
    TrainingComponent.prototype.setPrivateTagAndBool = function (bTags) {
        this.privateTag = this._tagService.findTagByName(bTags, 'Flight Training::Private');
        this.isPrivate = hasTag(this.business.tags, this.privateTag.tagName);
    };
    TrainingComponent.prototype.setCfi_FullTime_Subscription$ = function () {
        var _this = this;
        this.cfi_FullTime_Subscription$ = this.fullTimeInstructorRangeControl.valueChanges.pipe(debounceTime(1000)).subscribe(function (newVal) {
            _this.cfi_FullTime = newVal;
            _this.updateCfiCount(_this.cfi_FullTime);
        }, function (error) { return _this.snackBar.open(error, 'Error', { duration: 6000 }); });
    };
    TrainingComponent.prototype.setCfi_PartTime_Subscription$ = function () {
        var _this = this;
        this.cfi_PartTime_Subscription$ = this.partTimeInstructorRangeControl.valueChanges.pipe(debounceTime(1000)).subscribe(function (newVal) {
            _this.cfi_PartTime = newVal;
            _this.updateCfiCount(_this.cfi_PartTime);
        }, function (error) { return _this.snackBar.open(error, 'Error', { duration: 6000 }); });
    };
    TrainingComponent.prototype.setCfi_Contract_Subscription$ = function () {
        var _this = this;
        this.cfi_Contracted_Subscription$ = this.contractInstructorRangeControl.valueChanges.pipe(debounceTime(1000)).subscribe(function (newVal) {
            _this.cfi_Contracted = newVal;
            _this.updateCfiCount(_this.cfi_Contracted);
        }, function (error) { return _this.snackBar.open(error, 'Error', { duration: 6000 }); });
    };
    //#endregion
    TrainingComponent.prototype.isSectionVisible = function (sectionTags) {
        return this.editModeSet || sectionTags.some(function (sectionArray) { return sectionArray.length > 0; });
    };
    TrainingComponent.prototype.openEditTrainingDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '95%';
        var dialogRef = this._editTrainingDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                _this.loadAllBusinessTags();
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    TrainingComponent.prototype.approvedForVaTrainingChange = function (radioChange) {
        if (radioChange.source.value === '1' && !this.isApprovedForVaTraining) {
            this.isApprovedForVaTraining = true;
            this.updateTagStatus(this.vaApprovedTag, false);
        }
        else if (radioChange.source.value === '2' && this.isApprovedForVaTraining) {
            this.isApprovedForVaTraining = false;
            this.updateTagStatus(this.vaApprovedTag, true);
        }
    };
    TrainingComponent.prototype.isPrivateChange = function (checkboxChange) {
        if (checkboxChange.source.checked === true) {
            this.isPrivate = true;
            this.updateTagStatus(this.privateTag, false);
        }
        else if (checkboxChange.checked === false) {
            this.isPrivate = false;
            this.updateTagStatus(this.privateTag, true);
        }
    };
    TrainingComponent.prototype.updateTagStatus = function (tag, shouldDelete) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, tagId, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        tagId = tag.tagId;
                        if (!shouldDelete) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.deleteTag(tagId, this.business.id)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._tagService.postTag(tagId, this.business.id)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)
                            .then(function (newBusiness) { return Object.assign(_this.business, newBusiness); })];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        this.snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    TrainingComponent.prototype.updateCollegeName = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, collegeAffiliatedTag, collegeAffiliatedTagId, e_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, this._tagService.findTagByName(this.business.tags, 'Flight Training::College Affiliated')];
                    case 2:
                        collegeAffiliatedTag = _a.sent();
                        if (!(collegeAffiliatedTag != null && (name == null || name.length === 0))) return [3 /*break*/, 3];
                        this.updateTagStatus(collegeAffiliatedTag, true);
                        return [3 /*break*/, 5];
                    case 3:
                        if (!(name != null && name.length > 0)) return [3 /*break*/, 5];
                        collegeAffiliatedTagId = 181;
                        if (!(collegeAffiliatedTag == null)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._tagService.postTag(collegeAffiliatedTagId, this.business.id)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.business.collegeName = name;
                        return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)
                                .then(function (newBusiness) { return Object.assign(_this.business, newBusiness); })];
                    case 6:
                        _a.sent();
                        this.snackBar.open('College/University Affiliation updated', 'Success', {
                            duration: 6000
                        });
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        this.snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    TrainingComponent.prototype.updateCfiCount = function (num) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, e_3;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        if (!this.numberInRange(num, 0, 200)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        if (!this.business.flightSchool) {
                            this.business.flightSchool = new FlightSchool();
                        }
                        this.business.flightSchool.cfiCountFull = this.cfi_FullTime;
                        this.business.flightSchool.cfiCountPart = this.cfi_PartTime;
                        this.business.flightSchool.cfiCountContract = this.cfi_Contracted;
                        return [4 /*yield*/, this._businessManagerService.updateFlightSchool(this.business)
                                .subscribe(function (newBusiness) { return Object.assign(_this.business, newBusiness); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        this.snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    //#region Helper Functions
    TrainingComponent.prototype.numberInRange = function (num, min, max) {
        return (num >= min) && (num <= max);
    };
    return TrainingComponent;
}());
export { TrainingComponent };
